import { isPreview } from '@webapp/common/lib/const';
import { LocalStorage } from '@webapp/common/lib/storage';
import type { QuestionModel, ResidenceModel } from '@webapp/common/resources/entities';
import type { QuestionEntity } from '@webapp/common/resources/entities/question';
import { QuestionType } from '@webapp/common/resources/survey';

export type SavedAnswer = Pick<QuestionEntity, 'id' | 'answers' | 'groups' | 'response'>;

export const loadSavedAnswers = (
    domain: string,
    questions: Array<QuestionModel>,
    rawSavedAnswers?: Array<SavedAnswer> | null,
): Array<QuestionModel> => {
    let savedAnswers: Array<SavedAnswer> = rawSavedAnswers || [];

    try {
        if (savedAnswers.length === 0) {
            const parsedSavedQuestions = LocalStorage.get<Array<SavedAnswer>>(`new_answers__${domain}`);
            if (Array.isArray(parsedSavedQuestions)) {
                savedAnswers = parsedSavedQuestions;
            }
        }
    } catch (e) {}

    if (isPreview) {
        savedAnswers = [];
    }

    return questions.map((q, idx) => {
        const savedAnswer = savedAnswers.find(({ id }) => q.id === id);
        if (
            q.type === QuestionType.TEXT_BLOCK &&
            questions.slice(idx + 1).some((afterQuestion) => savedAnswers.find(({ id }) => afterQuestion.id === id))
        ) {
            return { ...q, savedAnswer: {} };
        }
        if (savedAnswer) {
            return { ...q, savedAnswer };
        }
        return q;
    });
};

export const prepareResidences = (rows: Array<any>, parent: number): Array<ResidenceModel> =>
    rows.map(({ ID: id, LEVEL: level, NAME: name }) => ({
        id,
        name,
        level: parseInt(level, 10),
        parent,
    }));
